import { InventoryItemDataDto } from "./InventoryItemDto";
import { InventoryItemDataModel } from "./InventoryItemModel";

export const transformInventoryItemDtoToModel = (
  dto: InventoryItemDataDto
): InventoryItemDataModel => dto;
